import React from 'react'
import PropTypes from 'prop-types'
import { Box, Typography } from '@mui/material'
import { CommonButton } from '@/components/common'
import { formatDisplayTime, formatIsoDateWithWeekday } from '@/utils'
import {
  StyledAppointmentCard,
  AppointmentDetails,
  AppointmentInfo,
  AppointmentFirstRow,
  AppointmentLocationField,
} from './styled'

export const AppointmentCard = ({
  date,
  time,
  location,
  procedureType,
  address,
  room,
  isUpcoming = false,
  onCancel,
  onReschedule,
  ...props
}) => {
  const formattedDate = formatIsoDateWithWeekday(date)
  const formattedTime = formatDisplayTime(time, 'h:mm a')

  return (
    <StyledAppointmentCard {...props}>
      <AppointmentDetails>
        <AppointmentInfo>
          <AppointmentFirstRow>
            <Box sx={{ display: 'flex' }}>
              {formattedDate && (
                <Typography variant='body1' component='span' fontWeight={600}>
                  {formattedDate}
                </Typography>
              )}
              {formattedTime && (
                <Typography
                  variant='body1'
                  fontWeight={600}
                  component='span'
                  sx={{ ml: 1 }}
                >
                  {formattedTime}
                </Typography>
              )}
            </Box>

            <Box sx={{ ml: { xs: 0, lg: 4 } }}>
              {location ? (
                <Typography variant='body1' component='span' fontWeight={600}>
                  {location}
                </Typography>
              ) : (
                <Box component='span'>&nbsp;</Box>
              )}
            </Box>
            <Box>
              {procedureType ? (
                <Typography variant='body1' component='span' fontWeight={600}>
                  {procedureType}
                </Typography>
              ) : (
                <Box component='span'>&nbsp;</Box>
              )}
            </Box>
          </AppointmentFirstRow>

          <Box
            sx={{
              display: 'flex',
              alignItems: { xs: 'flex-start', md: 'center' },
              flexDirection: { xs: 'column', md: 'row' },
            }}
          >
            {address && (
              <Typography
                variant='body2'
                sx={{ color: 'text.secondary', mt: 0.5 }}
              >
                {address}
              </Typography>
            )}
            {room && (
              <Typography
                variant='body2'
                sx={{ color: 'text.secondary', ml: { xs: 0, md: 3 }, mt: 0.5 }}
              >
                {room}
              </Typography>
            )}
          </Box>
        </AppointmentInfo>
        <Box
          sx={{
            ml: 'auto',
            alignSelf: 'flex-start',
            display: 'flex',
            flexDirection: 'row',
            gap: 1,
            flexShrink: 0,
          }}
        >
          {isUpcoming && (
            <>
              <CommonButton
                id='appointment-reschedule-btn'
                label='Reschedule'
                variant='primary'
                color='primary'
                size='medium'
                onClick={onReschedule}
              />
              <CommonButton
                id='appointment-cancel-btn'
                label='Cancel'
                variant='primary'
                color='primary'
                size='medium'
                onClick={onCancel}
              />
            </>
          )}
        </Box>
      </AppointmentDetails>
    </StyledAppointmentCard>
  )
}

AppointmentCard.propTypes = {
  date: PropTypes.string,
  time: PropTypes.string,
  location: PropTypes.string,
  procedureType: PropTypes.string.isRequired,
  address: PropTypes.string,
  showCancel: PropTypes.bool,
  onCancel: PropTypes.func,
  onReschedule: PropTypes.func,
}
